<template>
	<div class="tabs" :class="positionClass">
		<div class="tab-holder">
			<router-link v-for="(route, index) in routes" :to="{name: route.name}" :key="'tab-' + route.name" class="tab">
				{{ route.meta.title }}
			</router-link>
		</div>
		<div class="pane-holder">
			<transition name="slide-fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['position', 'routes'],
		computed: {
			positionClass() {
				return (this.position)?this.position:'';
			}
		}
	}
</script>